import { addModal } from 'weblite-web-modal-viewer'
import { CreateCourseDialog } from './create-course-dialog'

const COMPONENT_ID = 'createCourseDialog'

export function showCreateCourseDialog() {
  addModal({ id: COMPONENT_ID })
}

export default {
  [COMPONENT_ID]: {
    Component: CreateCourseDialog,
  },
}
